// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_textinput_btn-primary__2SBAR","input":"_textinput_input__2U5_E","inline":"_textinput_inline__2QtGe"};